import { PomodoroService } from "features/widget-workspace/service/PomodoroService";
import React, { useEffect } from "react";
import { useUserContext } from "@contexts/UserContext";
import { useAlarmSoundOptions } from "./useAlarmSoundOptions";
import { PomodoroSettingsInput, PomodoroSettingsInputAction } from "./usePomodoroSettingsInput";

export function useSelectedPomodoroSound(
    pomodoroService: PomodoroService,
    pomodoroSettingsInput: PomodoroSettingsInput,
    dispatchPomodoroSettingsInput: React.Dispatch<PomodoroSettingsInputAction>,
) {
    const { user, userData } = useUserContext();
    const alarmSoundOptions = useAlarmSoundOptions(pomodoroService);

    useEffect(() => {
        // If the user has saved configs, and is a pro/premium user, update their selected alarm
        if (userData?.pomodoroWidgetSettings?.selectedAlarmSrc) {
            if (
                alarmSoundOptions[userData.pomodoroWidgetSettings.selectedAlarmSrc]?.src &&
                userData.proUserInfo?.isProUser
            ) {
                dispatchPomodoroSettingsInput({
                    type: "setSelectedAlarmSound",
                    value: userData.pomodoroWidgetSettings.selectedAlarmSrc,
                });
            }
        } else if (user && userData && !userData?.pomodoroWidgetSettings?.selectedAlarmSrc) {
            pomodoroService.updateSelectedAlarmSrc?.(pomodoroSettingsInput.selectedAlarmSound);
        }
    }, [alarmSoundOptions]);
}
